<div class="header header2">
    <nav class="navbar navbar-default">
        <div class="navbar-header">
            <a class="navbar-brand" href="#"><img src="./assets/img/image-1.png" alt="logo"></a>
        </div>
    </nav>
</div>

<div class="bg_image boxs">
    <div class="box_fom boxs">
        <div class="form_bx boxs">
            <form (ngSubmit)="checkCaptcha()" id="login-form">
                <h2>Sign In</h2>
                <div class="form-group">
                    <label>Your email </label>
                    <input type="text" name="username" [(ngModel)]="user.username" class="form-control"
                        [disabled]="isLoading == 1" placeholder="Enter email">
                    <label for="password" class="error-custom">{{errors.email | translate}}</label>
                </div>
                <div class="form-group">
                    <label>password </label>
                    <input type="password" name="password" [(ngModel)]="user.password" class="form-control"
                        [disabled]="isLoading == 1" placeholder="Enter your password">
                    <label for="password" class="error-custom">{{errors.password | translate}}</label>
                </div>
                <div class="sign_btn boxs">
                    <button *ngIf="isLoading==1" type="button" class="hvr-sweep-to-right"><img
                            src="./assets/img/loading.gif" />
                        Loading</button>
                    <button *ngIf="isLoading==2" type="submit" class="hvr-sweep-to-right">SIGN IN</button>
                </div>
                <div align="center">
                    <label class="error-login">{{authError}}</label>
                </div>
            </form>
        </div>
    </div>
</div>